<ion-item
  class="empty-state"
  [ngClass]="{'detail-empty': detailEmpty}"
>

  <ion-label class="ion-text-wrap">
    @if (!!icon) {
      <yu-icon [name]="icon"></yu-icon>
    }

    <div class="title">{{ title }}</div>
    <div class="sub-title">{{ description }}</div>
  </ion-label>

</ion-item>

@if (buttonText) {

  <ion-item class="btn-item">

    <yu-button
      type="outline"
      color="gradient"
      size="small"
      (yuClick)="clickButton.emit()"
    >
      {{ buttonText }}
    </yu-button>

  </ion-item>

}
